import { Component, type ErrorInfo, type ReactNode } from "react";

interface Props {
  children: ReactNode;
  title?: string;
}

interface State {
  error: Error | null;
}

export class AppErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error("[Hospitol] Erreur interface", error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="container py-5">
          <div className="alert alert-danger">
            <h2 className="h5 fw-semibold mb-2">
              {this.props.title ?? "Une erreur est survenue"}
            </h2>
            <p className="mb-2 small">{this.state.error.message}</p>
            <button
              type="button"
              className="btn btn-outline-danger btn-sm"
              onClick={() => window.location.reload()}
            >
              Recharger la page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
